import React from 'react';
import { Route } from 'react-router-dom';

// <Link to={to}>{children}</Link>

const LiNavLink = ({children, to, exact}) => (

  <Route path={to} exact={exact} children={({match}) => (
    <li className={match ? 'is-active' : null}>
      {children}
    </li>
  )} />
);

export default LiNavLink;



// WEBPACK FOOTER //
// ./src/components/LiNavLink/index.js